import { biChartModel } from '@euler/app/components/message/widgets/bi-visualization/functions/biChartModel';
import { BiQueryResult } from '@euler/model/bi/result';
import { BiChartViz, BiPalette } from '@euler/model/bi/viz';

/** Something on the chart that takes a color: a series or a slice. */
export interface BiColorTarget {
  key: string;
  name: string;
  /** What it is drawn in now. */
  color: string;
}

/** Most series or slices the color list offers. */
const kMaxTargets = 12;

/**
 * What the chart colors, read from the preview: its measures, the values
 * of its `seriesBy` dimension, or its slices.
 */
export function biColorTargets(
  viz: BiChartViz,
  result: BiQueryResult | null,
  palette: BiPalette | undefined,
): BiColorTarget[] {
  const model = result ? biChartModel(viz, result, palette) : null;
  if (!model) return [];
  const targets =
    model.kind === 'pie'
      ? model.slices.map(slice => ({
          key: slice.key,
          name: slice.name,
          color: slice.color,
        }))
      : model.series.map(entry => ({
          key: entry.key,
          name: entry.name,
          color: entry.color,
        }));
  return targets.slice(0, kMaxTargets);
}
